<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        btntype="primary"
        title="新增"
        iconName="el-icon-plus"
        @click.native="openCreated"
        v-permission="'menu:save'"
      ></butn>
      <!--工具栏-->
      <div class="search_right">
        <Search @search="searchHandle" />
      </div>
    </div>
    <!--表格内容栏-->
    <Tables :data="menuList" @selection-change="selectionChange" />

    <!-- 编辑新增 -->
    <Curd @click="oNclick(dataName)" :menuTreeAllList="menuTreeAllList" />
    <!-- 详情 -->
    <Details />
  </div>
</template>
<script>
import Search from "./search";
import Curd from "./curd";
import butn from "@/components/button/index";
import Tables from "./table.js";
import Bus from "./Bus.js";
import Details from "./details";
import { getMenuTreeList, listDeleteByIds } from "@/api/menu";
function mergeLeaf(item) {
  if (!item.son) return item;
  return { ...item.itself, children: item.son.map(mergeLeaf) };
}
export default {
  name: "menu",
  components: { Tables, butn, Search, Curd, Details },
  data() {
    return {
      size: "small",
      filters: {
        name: "",
      },
      menuList: [],
      selections: [], // 列表选中列
      dialogFormVisible: false,
      dataName: "",
      menuTreeAllList: [],
    };
  },
  methods: {
    // 获取列表数据
    getMenuTreeList(params) {
      getMenuTreeList(params)
        .then((res) => {
          if (res && res.code == 0) {
            this.menuList = res.data;
            this.menuTreeAllList = res.data.map(mergeLeaf);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openCreated() {
      Bus.$emit("ReceiveMessage", "");
    },
    oNclick() {
      this.getMenuTreeList(this.dataName);
    },
    handlecreateData() {},
    // 全选/单选
    selectionChange: function (selections) {
      this.selections = selections;
    },
    //删除
    deleteHandle(menu) {
      this.$confirm(`确认要删除该菜单吗?`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          listDeleteByIds({ uuids: [menu.uuid] })
            .then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 带上历史条件更新列表
                this.getMenuTreeList(this.dataName);
                Bus.$emit("ReceiveMessage", "123");
                this.CUFlag = false;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    //搜索
    searchHandle(param) {
      this.dataName = param;
      this.getMenuTreeList(param);
    },
  },
  created() {
    var _this = this;
    _this.getMenuTreeList({});
    Bus.$on("deleteMenu", function (item) {
      _this.deleteHandle(item);
    });
  },
  mounted() {},
  computed: {
    menu() {
      return this.selections.map((item) => item.apiId).toString();
    },
  },
};
</script>
